module.exports = __webpack_public_path__ + "static/media/buy_req_make_6.f18603af.jpg";